export interface DashboardView {
  id?: string;
  dashboardId: string;
  viewName: string;
  layoutJson: DashboardLayoutConfig;
  isShared: boolean;
  organizationLevelId?: string;
  canManage?: boolean;
}

export interface DashboardLayoutConfig {
  columns: number;
  rowHeight: number;
  gap: number;
}

export interface DashboardViewLookup {
  id: string;
  name: string;
  isShared: boolean;
  canManage?: boolean;
  createdByUserId?: string;
}

export const DEFAULT_DASHBOARD_ID = 'GLOBAL_Dashboard';

export const DEFAULT_LAYOUT: DashboardLayoutConfig = {
  columns: 4,
  rowHeight: 17,
  gap: 16
};

export const createEmptyDashboardView = (viewName: string, organizationLevelId?: string): Partial<DashboardView> => ({
  dashboardId: DEFAULT_DASHBOARD_ID,
  viewName,
  layoutJson: { ...DEFAULT_LAYOUT },
  isShared: false,
  organizationLevelId
});
